function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { useAction } from 'hooks';
import Account from 'modules/Account';
import * as actions from '../../actions';
import { CONNECTION_STATUSES, CONNECTOR_TYPES } from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './DownloadDataModal.pcss';
const Waiting = ({ onSetComponent })=>{
    const connectionId = useSelector(selectors.connectionId);
    const connectionStatus = useSelector(selectors.connectionStatus);
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const organizationUID = get(activeClinicMembership, 'clinic.organizationUID');
    const onConnect = useAction(actions.connectScc, organizationUID);
    const onStartCheckingConnection = useAction(actions.startCheckingConnection);
    useEffect(()=>{
        onConnect();
    }, []);
    useEffect(()=>{
        if (connectionStatus === CONNECTION_STATUSES.INITIALIZED) {
            onStartCheckingConnection(connectionId, CONNECTOR_TYPES.SCC);
        } else if (connectionStatus) {
            onSetComponent('Downloading');
        }
    }, [
        connectionId,
        connectionStatus
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sccDownload.header))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: /*#__PURE__*/ _jsx("img", {
                    className: styles.centralImage,
                    src: "/assets/svg/data.svg",
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info text--center mb-5",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sccDownload.waitingInfo))
            })
        ]
    });
};
export default Waiting;
